import React from 'react'

import CurrentAccountSelect from '../../containers/integrations/Omie/CurrentAccountSelect'
import DepartamentsSelect from '../../containers/integrations/Omie/Departments'
import CustomerSelect from '../../containers/integrations/Omie/CustomerSelect'
import ServiceOrCNAESelect from '../../containers/integrations/Omie/ServiceOrCNAESelect'
import TaxationTypeSelect from '../../containers/integrations/Omie/TaxationTypeSelect'
import ServiceLC116Select from '../../containers/integrations/Omie/ServiceLC116Select'
import InstallmentsSelect from '../../containers/integrations/Omie/InstallmentsSelect'
import CategorySelect from '../../containers/integrations/Omie/CategorySelect'
import CategorySelectNibo from '../../containers/integrations/Nibo/CategorySelect'
import BankAccountsSelectNibo from '../../containers/integrations/Nibo/BankAccountsSelect'

import Text from '../../packages/kiti/components/presentation/Text'
import SellerSelect from '../../containers/integrations/Omie/SellerSelect'
import ProjectSelect from '../../containers/integrations/Omie/ProjectSelect'
import DocumentTypeSelect from '../../containers/integrations/Omie/DocumentTypeSelect'

const renderInput = ({ integrationId, integrationFieldType, value, onChange, props }) => {
  switch (integrationFieldType) {
    case 'cCodCateg':
      return <CategorySelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'nCodCC':
      return <CurrentAccountSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cTribServ':
      return <TaxationTypeSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cCodServMun':
      return <ServiceOrCNAESelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cCodServLC116':
      return <ServiceLC116Select value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'nQtdeParc':
      return <InstallmentsSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cCodCategNibo':
      return <CategorySelectNibo value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cCodBank':
      return <BankAccountsSelectNibo value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cCodCustomerOmie':
      return <CustomerSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'cDepartmentOmie':
      return <DepartamentsSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'codVend':
      return <SellerSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'projects':
      return <ProjectSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    case 'documentType':
      return <DocumentTypeSelect value={value} onChange={onChange} {...props} filter={{ integrationId }} />

    default:
      return <Text>**Campo em desenvolvimento**</Text>
  }
}

const DynamicIntegrationInput = ({ integrationId, integrationFieldType, value, onChange, props }) => {
  return renderInput({ integrationId, integrationFieldType, value, onChange, props })
}
export default DynamicIntegrationInput
